import { routerFrom } from "router";

export const routes = [
  {
    acl: [],
    label: "Profiles List",
    name: "profiles-list",
    path: "/profiles-list",
    exact: true,
  },
  {
    acl: [],
    label: "Requests to join list",
    name: "requests-to-join-list",
    path: "/requests-to-join-list",
    exact: true,
  },
];

export const router = routerFrom(routes);
